'use client';

import { c as _c } from "react/compiler-runtime";
import { type FC, memo, useEffect, useMemo } from 'react';
import { useVerificationPolling } from '../../hooks/use-verification-polling';
import { useVerificationStore } from '../../store/verificationStoreProvider';
import { SuccessSocialVerificationModal } from '../UserForm/SucessSocialVerificationModal';

/**
 * Компонент для глобального управления уведомлениями верификации
 *
 * Монтируется в Layout и отвечает за:
 * - Запуск polling верификации через хук
 * - Синхронизацию состояния с Zustand store
 * - Отображение модалки успешной верификации
 */
const VerificationNotificationComponent: FC = () => {
  const $ = _c(17);
  const {
    confirmedSocials,
    verifiedSocials,
    startPolling,
    stopPolling,
    clearConfirmedSocials
  } = useVerificationPolling();
  const setStartPollingCallback = useVerificationStore(_temp);
  const setStopPollingCallback = useVerificationStore(_temp2);
  const setConfirmedPlatforms = useVerificationStore(_temp3);
  let t0;
  let t1;
  if ($[0] !== setStartPollingCallback || $[1] !== startPolling) {
    t0 = () => {
      setStartPollingCallback(startPolling);
    };
    t1 = [startPolling, setStartPollingCallback];
    $[0] = setStartPollingCallback;
    $[1] = startPolling;
    $[2] = t0;
    $[3] = t1;
  } else {
    t0 = $[2];
    t1 = $[3];
  }
  useEffect(t0, t1);
  let t2;
  let t3;
  if ($[4] !== setStopPollingCallback || $[5] !== stopPolling) {
    t2 = () => {
      setStopPollingCallback(stopPolling);
    };
    t3 = [stopPolling, setStopPollingCallback];
    $[4] = setStopPollingCallback;
    $[5] = stopPolling;
    $[6] = t2;
    $[7] = t3;
  } else {
    t2 = $[6];
    t3 = $[7];
  }
  useEffect(t2, t3);
  const stableConfirmedSocialsKey = JSON.stringify(verifiedSocials);
  const memoizedConfirmedPlatforms = verifiedSocials;
  let t4;
  if ($[8] !== memoizedConfirmedPlatforms || $[9] !== setConfirmedPlatforms) {
    t4 = () => {
      setConfirmedPlatforms(memoizedConfirmedPlatforms);
    };
    $[8] = memoizedConfirmedPlatforms;
    $[9] = setConfirmedPlatforms;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== memoizedConfirmedPlatforms) {
    t5 = [memoizedConfirmedPlatforms];
    $[11] = memoizedConfirmedPlatforms;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  useEffect(t4, t5);
  const t6 = confirmedSocials.length > 0;
  let t7;
  if ($[13] !== clearConfirmedSocials || $[14] !== confirmedSocials || $[15] !== t6) {
    t7 = <SuccessSocialVerificationModal open={t6} onClose={clearConfirmedSocials} platform={confirmedSocials} />;
    $[13] = clearConfirmedSocials;
    $[14] = confirmedSocials;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
};
export const VerificationNotification = memo(VerificationNotificationComponent);
function _temp(store) {
  return store.setStartPollingCallback;
}
function _temp2(store_0) {
  return store_0.setStopPollingCallback;
}
function _temp3(store_1) {
  return store_1.setConfirmedPlatforms;
}